import React, { Component, Fragment } from "react";
// import { Link } from "react-router-dom";

// import { Navbar, NavLink, Nav } from "react-bootstrap";
//import Nav from "react-bootstrap/Nav";

//import { storeValue, getAuthUser } from "../../utils/sessionManager";
import HeroSection from "./HeroSection";
import Products from './Products'
import AppSuite from './AppSuite'
import Slider from './Slider'
import Clients from './Clients'
import Footer from './Footer'
import Seo from './Seo'
//import Footer from "../../components/Footer/Footer";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // componentDidMount() {
  //   window.scrollTo(0, 0);
  //   // const url = 'https://api.ipdata.co?api-key=b58297acf4771a5e61085ec1506c807d9aa36b0a31f2ef937657e6fc';
  //   const url = "https://ip-api.io/api/json";
  //   const loc = getAuthUser("user_location");
  //   if (!loc) {
  //     fetch(url)
  //       .then((res) => res.json())
  //       .then((response) => {
  //         const locRes = response;
  //         // console.log('Success:', locRes);
  //         const user_location = {
  //           country_code: locRes.country_code,
  //           country_name: locRes.country_name,
  //           region_code: locRes.region_code,
  //           region_name: locRes.region_name,
  //           city: locRes.city,
  //         };
  //         storeValue("user_location", user_location);
  //       })
  //       .catch((error) => console.error("Home Error:"));
  //   }
  // }

  clickedLogo = () => {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <Fragment>
        <div id="home">
          {/* <div className="section_1">
            <Navbar
              collapseOnSelect
              bg="light"
              variant="light"
              expand="md"
              fixed="top"
            >
              <div className="container-fluid">
                <Navbar.Brand>
                  <Link to="/" onClick={() => this.clickedLogo()}>
                    <img
                      src={`/images/pulse_lab.png`}
                      className="img-fluid d-block logo_style"
                      alt="NJ Asset Management Private Limited"
                    />
                    
                  </Link>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic_navbar_nav_home" />
                <Navbar.Collapse
                  id="basic_navbar_nav_home"
                  className="justify-content-end"
                >
                  <Nav className="justify-content-end">
                    <Nav.Item>
                      <NavLink href="#home" className="nav-link view_link">
                        Home
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink href="#about_us" className="nav-link view_link">
                        About Us
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink href="#products" className="nav-link view_link">
                        Products
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink href="#contact_us" className="nav-link view_link">
                        Contact Us
                      </NavLink>
                    </Nav.Item>
                  </Nav>
                </Navbar.Collapse>
              </div>
            </Navbar>
          </div> */}
          <div >
            <HeroSection />
            <div >
              <div id="about_us" className="container-fluid second_section_text">
                <h2  className="text-center mt-5 ">Who we serve</h2>
                <div className="row my-5 justify-content-around">
                  <div className="col-md-3 card_style m-1">
                    <image className="fa fa-bank pt-5 " alt="fa fa-bank"></image>
                    <h3 className="py-3">Robos/Banks/FIs</h3>
                    <p>
                      In this digital age, getting an eye-ball in your site is the
                      most crucial feat. How intuitive & visually appealing you make
                      it, best decides the outcome.
                      <br></br>As you focus on UX, we power you with all the data
                      that you can possibly fathom.
                    </p>
                  </div>
                  <div className="col-md-3 card_style m-1">
                    <img className='pt-4' src='../images/mdi_microsoft-office.png' alt="PGIM India Asset Management Private Limited"></img>
                    <h3 className="py-3">Multi Family Offices</h3>
                    <p>
                      Customization is the key when you engage UHNW clients.
                      <br></br>Whether it is Attribution Analysis, Optimization
                      Modeling, Monte-Carlo, Asset-Allocation Strategies or just
                      about anything under quant, we bet to get you an edge over the
                      Private Bank.
                    </p>
                  </div>
                  <div className="col-md-3 card_style m-1">
                    <image className="fa fa-cube pt-5 " alt="fa fa-cube"></image>
                    <h3 className="py-3">RIAs/IFAs</h3>
                    <p>
                      Dealing with Masses with Class. This is what a successful IFA
                      business model would aspire for.
                      <br></br>
                      Our SaaS Models helps you to scale & compete with any big
                      player, without leaving many holes in the pocket.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <Products />
            <AppSuite />
            <Slider />
            <Clients />
            <Footer />
            <Seo />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Home;
